import React, { useRef, useState, useEffect } from 'react'
import Buttons from '../../../../components/ui/button/Buttons';
import TeamProjectFormData from './TeamProjects.Data';
import { useAddTeamProjectMutation } from '../../../../app/services/teamProjectsAPI';
import { useLazyGetAllProjectsQuery } from '../../../../app/services/projectManagementAPI'
import ToastService from '../../../../services/toastService/ToastService';
import { useSelector } from 'react-redux';
import FormCreator from '../../../../components/finalForms/FormCreator';
import { mapDropdownOptions } from '../../../../components/finalForms/libs/mapDropdownOptions';

const AddEditTeamProjects = (props) => {
  const TeamRef = useRef();
  const [formData, setFormData] = useState({ ...TeamProjectFormData });

  const teamId = useSelector((state) => state.teamProjectManagement.teamData.teamId);

  const [addTeamProject,
    { isSuccess: isTeamProjectAdded, isLoading: isTeamProjectAdding, data: addTeamProjectData },] = useAddTeamProjectMutation();

  const [
    getAllProjects,
    { isFetching: isProjectFetching, isSuccess: isProjectFetched, data: AllProjectData },
  ] = useLazyGetAllProjectsQuery();


  useEffect(() => {
    getAllProjects();
  }, [getAllProjects]);

  useEffect(() => {
    if (isProjectFetched && !isProjectFetching && AllProjectData) {
      const updatedFormData = { ...formData }
      mapDropdownOptions(
        TeamProjectFormData,
        'TeamProject',
        'projectId',
        AllProjectData,
        'projectId',
        'projectName'
      );
      setFormData(updatedFormData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProjectFetched, isProjectFetching, AllProjectData]);

  const handalSubmitData = () => {
    const TeamProjectFormData = TeamRef.current.getFormData();
    if (TeamProjectFormData) {
      const requestData = {
        ...TeamProjectFormData,
        teamId: teamId,
        projectIds: TeamProjectFormData?.projectId?.join(",")
      }
      addTeamProject(requestData);
    }
  }

  useEffect(() => {
    if (isTeamProjectAdded && addTeamProjectData) {
      if (addTeamProjectData.errorMessage.includes("exists")) {
        ToastService.warning(addTeamProjectData.errorMessage);
        return;
      }
      else {
        ToastService.success(addTeamProjectData.errorMessage);
        backToList();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTeamProjectAdded, addTeamProjectData]);

  const backToList = () => {
    props.onClose();
  };

  return (
    <>
      <form>
        <div className="row">
           <FormCreator config={formData}  ref={TeamRef} />
        </div>
      </form>
      <div className="d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          buttonText="Cancel"
          onClick={backToList}
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          buttonText="Add"
          onClick={handalSubmitData}
          isLoading={isTeamProjectAdding}
        />
      </div>
    </>
  )
}

export default AddEditTeamProjects;
